import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from 'common/helmets/Helmet';

const Title = 'Document360 Case Study | Canny';
const Description =
  'Read about how Document360 uses Canny to be customer-obsessed and close new business';
const Image = 'https://canny.io/images/e118b699e2e1b7291a2448eb5990465a.jpg';
const Document360Url = 'https://canny.io/case-studies/document360';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${Document360Url}#webpage`,
    url: Document360Url,
    name: 'Case Study: Document360 × Canny',
    description: 'How Document360 uses Canny to be customer-obsessed and close new business.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${Document360Url}#article`,
    genre: 'Case Study',
    headline: 'How Document360 uses Canny to be customer-obsessed and close new business',
    description:
      'Document360 replaced Excel-based feature tracking with Canny to handle growing feedback from Sales and CS. The intuitive UI, analytics, and Teams integration help them identify top requests, prioritize using Boards and trending data, and stay transparent with customers through a public roadmap—boosting trusted engagement and accelerating growth.',
    inLanguage: 'en',
    url: Document360Url,
    mainEntityOfPage: { '@id': `${Document360Url}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Document360', url: 'https://document360.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Document360', item: Document360Url },
  ]),
]);

const Document360LandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: Document360Url },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}>
      <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
    </Helmet>
  );
};

export default Document360LandingHelmet;
